<template>
  <div>
    <h1>{{activeLead ? "Détails - Lead" : "Dashboard - Leads"}}</h1>
    <div v-if="activeLeadId == undefined">
      <div class="form-selection-container">
        <h2 class="d-flex justify-content-between">
          <span>Campagnes de Lead</span>
          <font-awesome-icon v-if="formSelectDisplay" class="icon" icon="angle-down" @click="formSelectDisplay = !formSelectDisplay" />
          <font-awesome-icon v-else class="icon" icon="angle-up" @click="formSelectDisplay = !formSelectDisplay"/>
        </h2>
        <ul v-if="formSelectDisplay">
          <li v-for="form of forms" :key="form.Id">
            <label>
              <input :disabled="!form.Active" type="checkbox" v-model="selectedForms" :value="form.Id" />
              <span class="form-name">{{form.Name}}</span>
              <span class="form-date">{{formatDate(form.CreatedTime, true)}}</span>
              <span class="form-nb-lead">
                <span class="number">{{form.nbLead}}</span>
                <span>leads</span>
              </span>
            </label>
          </li>
        </ul>
      </div>
      <ul class="overview-data">
        <li :style="{borderBottomColor: getStatus(0).Color}">
          <div class="section">
            <span class="count">
              {{overviewData.untreated}}
                <small>({{calcPercent(overviewData.untreated, overviewData.received)}} %)</small>
            </span>
            demandes reçues
          </div>
          <div class="sub-sections">
            <div class="section">
              <span class="count">
                {{overviewData.jp2}}
                <small>({{calcPercent(overviewData.jp2, overviewData.untreated)}} %)</small>
              </span>
              <span class="yellow">J+2</span>
            </div>
            <div class="section">
              <span class="count">
                {{overviewData.jp4}}
                <small>({{calcPercent(overviewData.jp4, overviewData.untreated)}} %)</small>
              </span>
              <span class="orange">J+4</span>
            </div>
            <div class="section">
              <span class="count">
                {{overviewData.jp6}}
                <small>({{calcPercent(overviewData.jp6, overviewData.untreated)}} %)</small>
              </span>
              <span class="red">J+6</span>
            </div>
          </div>
        </li>
        <li :style="{borderBottomColor: getStatus(2).Color}">
          <div class="section">
            <span class="count">
              {{overviewData.inProgress}}
              <small>({{calcPercent(overviewData.inProgress, overviewData.received)}} %)</small>
            </span>
            échanges en cours
          </div>
          <div class="sub-sections">
            <div class="section">
              <span class="count">
                {{overviewData.read}}
                <small>({{calcPercent(overviewData.read, overviewData.inProgress)}} %)</small>
              </span>
              lu
            </div>
            <div class="section">
              <span class="count">
                {{overviewData.called}}
                <small>({{calcPercent(overviewData.called, overviewData.inProgress)}} %)</small>
              </span>
              appelés
            </div>
            <div class="section">
              <span class="count">
                {{overviewData.estimateSend}}
                <small>({{calcPercent(overviewData.estimateSend, overviewData.inProgress)}} %)</small>
              </span>
              devis envoyés
            </div>
          </div>
        </li>
        <li :style="{borderBottomColor: getStatus(9).Color}">
          <div class="section">
            <span class="count">
              {{overviewData.ended}}
              <small>({{calcPercent(overviewData.ended, overviewData.received)}} %)</small>
            </span>
            échanges terminés
          </div>
          <div class="sub-sections">
            <div class="section">
              <span class="count">
                {{overviewData.signedEstimate}}
                <small>({{calcPercent(overviewData.signedEstimate, overviewData.ended)}} %)</small>
              </span>
              <span class="green">devis signés</span>
            </div>
            <div class="section">
              <span class="count">
                {{overviewData.ended - overviewData.signedEstimate}}
                <small>({{calcPercent(overviewData.ended - overviewData.signedEstimate, overviewData.ended)}} %)</small>
              </span>
              <span class="red">échanges non aboutis</span>
            </div>
          </div>
        </li>
      </ul>
      <div class="leads-table-container">
        <div class="d-flex justify-content-between align-items-center">
          <h2>Liste des demandes</h2>
          <div class="d-flex">
            <label>
              Cacher les leads terminés
              <input type="checkbox" v-model="onlyNonEnded" />
            </label>
          </div>
        </div>
        <vue-good-table class="leads-table"
                        :columns="columns"
                        :rows="filteredLeadsLastState.filter(l => !onlyNonEnded || !getStatus(l.StatusId).IsEnded)"
                        :sort-options="{
                                    enabled: true,
                                    multipleColumns: true,
                                    initialSortBy: {field: 'Date', type: 'desc'}
                                  }"
                        :pagination-options="{
                                        enabled: true,
                                        rowsPerPageLabel: 'Lignes par page',
                                        ofLabel: 'sur',
                                        nextLabel: 'Suivant',
                                        prevLabel: 'Précédent',
                                        allLabel: 'Toutes'
                                    }">
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'none'">
              <router-link :to="{ path: 'leads', query: { idlead: props.row.Id }}" class="btn detail-btn">Détails</router-link>
            </span>
            <span v-else>
              {{props.formattedRow[props.column.field]}}
            </span>
          </template>
        </vue-good-table>
      </div>
    </div>
    <div v-else>
      <div class="detail-overview-container">
        <div>
          <h2>Demandeur</h2>
          <div class="content">
            <div>
              <span>Nom :</span>
              <span>{{activeLead ? activeLead.FullName : ""}}</span>
              <span>Mail :</span>
              <span>{{activeLead ? activeLead.Mail : ""}}</span>
              <span>Tel :</span>
              <span>{{activeLead ? activeLead.Phone : ""}}</span>
            </div>
            <div>
              <span>Code Postal :</span>
              <span>{{activeLead ? activeLead.PostalCode : ""}}</span>
              <span>Province :</span>
              <span>{{activeLead ? activeLead.Region : ""}}</span>
              <span>Date demande :</span>
              <span>{{activeLead ? formatDate(activeLead.Date, true) : ""}}</span>
            </div>
          </div>
        </div>
        <div>
          <h2>Négoce</h2>
          <div class="content">
            <div>
              <span>Nom :</span>
              <span>{{activeLead ? activeLead.SocietyInfos.Name : ""}}</span>
              <span>Contact :</span>
              <span>{{activeLead ? activeLead.SocietyInfos.ContactFullName : ""}}</span>
              <span>Mail :</span>
              <span>{{activeLead ? activeLead.SocietyInfos.Mail : ""}}</span>
              <span>Tel :</span>
              <span>{{activeLead ? activeLead.SocietyInfos.Phone : ""}}</span>
            </div>
            <div>
              <span>Code Postal :</span>
              <span>{{activeLead ? activeLead.SocietyInfos.PostalCode : ""}}</span>
              <span>Ville :</span>
              <span>{{activeLead ? activeLead.SocietyInfos.City : ""}}</span>
              <span>Adresse :</span>
              <span>{{activeLead && activeLead.SocietyInfos.Address ? activeLead.SocietyInfos.Address.trim() : ""}}</span>
            </div>
          </div>
        </div>
        <div>
          <h2>Formulaire</h2>
          <div class="content" v-if="activeLead">
            <strong>{{activeLead.FormTitle}}</strong>
          </div>
        </div>
        <div>
          <h2>Statut</h2>
          <div class="content" v-if="activeLead">
            <strong>{{activeLead.Status}}</strong>
            <ProgressBar :borderColor="getStatus(activeLead.StatusId).Color"
                         :percentList="[{percent: getStatus(activeLead.StatusId).PercentBar, color: getStatus(activeLead.StatusId).Color}]">
            </ProgressBar>
          </div>
        </div>
      </div>
      <div class="lead-history-table-container">
        <h2>Echanges</h2>
        <table class="lead-history-table">
          <thead>
            <tr>
              <th>Statut</th>
              <th>Statut textuel</th>
              <th>Commentaire</th>
              <th>Date</th>
              <th>Utilisateur</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="activeLead && !getStatus(activeLead.StatusId).IsEnded">
              <td>
                <ProgressBar :border-color="getStatus(creatingState.StatusId).Color" :percentList="[{percent: getStatus(creatingState.StatusId).PercentBar, color: getStatus(creatingState.StatusId).Color}]"></ProgressBar>
              </td>
              <td>
                <select class="form-control" v-model="creatingState.StatusId">
                  <option :value="-1"></option>
                  <option v-for="statusRow of status.filter(s => s.Id > 1)" :key="statusRow.Id" :value="statusRow.Id">
                    {{statusRow.Status + (statusRow.IsEnded ? " (échange terminé)" : "")}}
                  </option>
                </select>
              </td>
              <td>
                <input class="form-control" type="text" v-model="creatingState.Comment" />
              </td>
              <td>
                <input class="form-control" type="datetime-local" v-model="creatingState.Date" />
              </td>
              <td></td>
              <td><button class="btn btn-success" @click="createState">Ajouter</button></td>
            </tr>
            <tr v-for="state of activeLeadStates" :key="state.EstimateStateId">
              <td>
                <ProgressBar v-if="state.EstimateStateId !== updatingStateId" :border-color="getStatus(state.StatusId).Color" :percentList="[{percent: getStatus(state.StatusId).PercentBar, color: getStatus(state.StatusId).Color}]"></ProgressBar>
                <ProgressBar v-else :border-color="getStatus(updatingState.StatusId).Color" :percentList="[{percent: getStatus(updatingState.StatusId).PercentBar, color: getStatus(updatingState.StatusId).Color}]"></ProgressBar>
              </td>
              <td>
                <span v-if="state.EstimateStateId !== updatingStateId">
                  {{state.Status}}
                </span>
                <select v-else class="form-control" v-model="updatingState.StatusId">
                  <option v-for="statusRow of status.filter(s => s.Id > 1)" :key="statusRow.Id" :value="statusRow.Id">
                    {{statusRow.Status + (statusRow.IsEnded ? " (échange terminé)" : "")}}
                  </option>
                </select>
              </td>
              <td>
                <span v-if="state.EstimateStateId !== updatingStateId">
                  {{state.Comment}}
                </span>
                <input v-else type="text" class="form-control" v-model="updatingState.Comment" />
              </td>
              <td>
                <span v-if="state.EstimateStateId !== updatingStateId">
                  {{formatDateTime(new Date(state.StatusDate), true)}}
                </span>
                <input v-else type="datetime-local" class="form-control" v-model="updatingState.StatusDate" />
              </td>
              <td>
                {{state.UserName}}
              </td>
              <td>
                <div class="btn-group" v-if="$store.state.self.isAdmin || state.UserId == $store.state.self.id">
                  <button class="btn btn-warning" v-if="updatingStateId !== state.EstimateStateId" @click="updatingStateId = state.EstimateStateId;updatingState=Object.assign({}, state, {StatusDate: formatDateTime(new Date(state.StatusDate))})"><font-awesome-icon icon="pen"></font-awesome-icon></button>
                  <button class="btn btn-warning" v-else @click="updatingStateId = null;updatingState = {}"><font-awesome-icon icon="undo"></font-awesome-icon></button>
                  <button class="btn btn-success" v-if="updatingStateId === state.EstimateStateId" @click="updateState(state.EstimateStateId)"><font-awesome-icon icon="check"></font-awesome-icon></button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</template>

<script>
  import { calcPercent } from "@/utils";
  import mme from "@/utils/mme";
  import ProgressBar from "@/components/ProgressBar"

  export default {
    name: "Leads",
    components: {
      ProgressBar
    },
    data() {
      return {
        onlyNonEnded: true,
        formSelectDisplay: true,
        leadsLastState: [],
        leads: [],
        status: [],
        forms: [],
        selectedForms: [],
        activeLeadId: null,
        updatingStateId: null,
        updatingState: {},
        creatingState: {
          StatusId: -1,
          Comment: "",
          Date: this.formatDateTime(new Date())
        }
      }
    },
    mounted() {
      //mme.importData();
      mme.getStatus().then(res => this.status = res); // On récupère les infos sur les status des leads (appelé/mail envoyé/etc.)
      this.fetchData();

      this.activeLeadId = this.$route.query.idlead;
      if (this.activeLeadId) // Si on veut le détail d'un lead particulier (page unitaire)
        mme.readLead(this.activeLeadId).then(this.fetchData) // On envoie un accusé de lecture en back
    },
    watch: {
      $route() {
       // Si la route change, on met à jour l'id du lead sélectionné
        this.activeLeadId = this.$route.query.idlead;
        if (this.activeLeadId)
          mme.readLead(this.activeLeadId).then(this.fetchData)
      }
    },
    computed: {
      columns() {
        return [
          { label: "Prénom/Nom", field: "FullName", filterOptions: { enabled: true } },
          { label: "Mail", field: "Mail", filterOptions: { enabled: true } },
          { label: "Téléphone", field: "Phone", filterOptions: { enabled: true } },
          { label: "Code Postal", field: "PostalCode", filterOptions: { enabled: true } },
          { label: "Province", field: "Region", filterOptions: { enabled: true } },
          { label: "Date de création", field: "Date", type: "date", dateInputFormat: "yyyy-MM-dd", dateOutputFormat: "dd/MM/yyyy", filterOptions: { enabled: true } },
          { label: "Formulaire", field: "FormTitle", filterOptions: { enabled: true } },
          { label: "Négoce", field: "SocietyInfos.Name", filterOptions: { enabled: true } },
          {
            label: "Statut", field: "Status", filterOptions: {
              enabled: true,
              placeholder: "Tous",
              filterDropdownItems: this.status.map(s => s.Status)
            }
          },
          { label: "Dernière activité", field: "LastActivityDate", type: "date", dateInputFormat: "yyyy-MM-dd", dateOutputFormat: "dd/MM/yyyy", filterOptions: { enabled: true } },
          { label: "Commentaire", field: "Comment", filterOptions: { enabled: true } },
          { label: "Détails", field: "none" },
        ]
      },
      overviewData() {
        //Données recap du tableau de bord
        let res = {
          received: 0,
          untreated: 0,
          inProgress: 0,
          ended: 0,
          signedEstimate: 0,
          jp2: 0,
          jp4: 0,
          jp6: 0,
          read: 0,
          called: 0,
          estimateSend: 0,
        }
        this.filteredLeadsLastState.forEach(l => {
          res.received += 1
          if (l.StatusId == 0) res.untreated += 1
          if (l.StatusId != 0 && !this.getStatus(l.StatusId).IsEnded) res.inProgress += 1
          if (this.getStatus(l.StatusId).IsEnded) res.ended += 1
          if (l.StatusId == 7) res.signedEstimate += 1
          const dateDiff = this.dateDiffInDay(new Date(l.Date), new Date())
          if (l.StatusId == 0) {
            if (dateDiff > 6) res.jp6 += 1
            else if (dateDiff > 4) res.jp4 += 1
            else if (dateDiff > 2) res.jp2 += 1
          }
        })


        let alreadyCountedLead = { sendedEstimate: [], called: [], read: [] }
        // Pour ces données, on ne se base pas forcément sur le dernier état,
        // il faut tout parcourir, et ne pas compte le même lead plusieurs fois si le même état
        // a été renseigné plusieurs fois
        this.leads.forEach(lead => {
          const currentLeadLastState = this.filteredLeadsLastState.find(l => l.Id == lead.Id);
          if (currentLeadLastState && !this.getStatus(currentLeadLastState.StatusId).IsEnded) { // Appartient à une campagne sélectionnée
            if (lead.StatusId == 6 && alreadyCountedLead.sendedEstimate.indexOf(lead.Id) == -1) {
              res.estimateSend += 1;
              alreadyCountedLead.sendedEstimate.push(lead.Id)
            }
            if (lead.StatusId == 1 && alreadyCountedLead.read.indexOf(lead.Id) == -1) {
              res.read += 1;
              alreadyCountedLead.read.push(lead.Id)
            }
            if (lead.StatusId == 2 && alreadyCountedLead.called.indexOf(lead.Id) == -1) {
              res.called += 1;
              alreadyCountedLead.called.push(lead.Id)
            }
          }
        })
        return res;
      },
      activeLeadStates() {
        return this.leads.filter(lead => lead.Id == this.activeLeadId);
      },
      activeLead() {
        return this.leadsLastState.find(lead => lead.Id == this.activeLeadId);
      },
      filteredLeadsLastState() {
        return this.leadsLastState
          .filter(l => this.selectedForms.indexOf(l.FormId) !== -1)
      },
    },
    methods: {
      calcPercent,
      dateDiffInDay(date1, date2) {
        // Calcule le nombre de jour entre 2 dates
        return (date2 - date1) / 1000 / 60 / 60 / 24;
      },
      fetchData() {
        let p = new Promise((resolve, reject) => {
          let nbOk = 0;
          // on récupère d'abord les leads avec leur dernier état
          mme.getLeads(true).then(res => {
            this.leadsLastState = res.map(el => ({
              ...el,
              Date: this.formatDate(el.Date),
              StatusDate: this.formatDateTime(new Date(el.StatusDate)),
              LastActivityDate: this.formatDate(el.StatusDate)
            }))
            this.creatingState.Date = this.formatDateTime(new Date());
            nbOk += 1;
            if (nbOk == 2) resolve()
          });
          // puis le détail avec tous les états
          mme.getLeads().then(res => {
            this.leads = res.map(el => ({
              ...el,
              Date: this.formatDate(el.Date),
              StatusDate: this.formatDateTime(new Date(el.StatusDate)),
              LastActivityDate: this.formatDate(el.StatusDate)
            }))
            nbOk += 1;
            if (nbOk == 2) resolve()
          });
        })

        p.then(() => {
          // Après avoir récupéré tous les leads, on récupère les différentes campagnes
          mme.getForms().then(res => {
            console.log("res: ", res);
            this.forms = res
              .map(f => ({ ...f, nbLead: this.leadsLastState.filter(l => l.FormId == f.Id).length }))
              .filter(f => f.Active && f.nbLead > 0)
              .sort((a, b) => ((new Date(a.CreatedTime)) < (new Date(b.CreatedTime))) ? 1 : -1);
            console.log("forms: ", this.forms)
            if (this.forms && this.forms.length > 0)
              this.selectedForms.push(this.forms[0].Id); // On sélectionne par défaut la dernière campagne
          })
        })
      },
      formatDate(dateString, display = false) {
        if (!dateString) return null;
        const dateObj = new Date(dateString);
        if (!display)
          return `${dateObj.getFullYear()}-${(dateObj.getMonth() + 1 < 10) ? "0" : ""}${dateObj.getMonth() + 1}-${(dateObj.getDate() < 10) ? "0" : ""}${dateObj.getDate()}`
        else
          return `${(dateObj.getDate() < 10) ? "0" : ""}${dateObj.getDate()}/${(dateObj.getMonth() + 1 < 10) ? "0" : ""}${dateObj.getMonth() + 1}/${dateObj.getFullYear()}`
      },
      formatDateTime(date, display = false) {
        if (!date) return null;
        if (!display)
          return `${date.getFullYear()}-${(date.getMonth() + 1 < 10) ? "0" : ""}${date.getMonth() + 1}-${(date.getDate() < 10) ? "0" : ""}${date.getDate()}T${date.getHours() < 10 ? "0" : ""}${date.getHours()}:${date.getMinutes() < 10 ? "0" : ""}${date.getMinutes()}:${date.getSeconds() < 10 ? "0" : ""}${date.getSeconds()}`
        else
          return `${(date.getDate() < 10) ? "0" : ""}${date.getDate()}/${(date.getMonth() + 1 < 10) ? "0" : ""}${date.getMonth() + 1}/${date.getFullYear()} ${date.getHours() < 10 ? "0" : ""}${date.getHours()}:${date.getMinutes() < 10 ? "0" : ""}${date.getMinutes()}:${date.getSeconds() < 10 ? "0" : ""}${date.getSeconds()}`
      },
      getStatus(statusId) {
        return this.status.find(s => s.Id == statusId) || { Position: -1, Color: 'white', PercentBar: 0, IsEnded: false }
      },
      updateState(stateId) {
        mme.updateEstimateState(stateId, this.activeLeadId, this.updatingState.StatusId, this.updatingState.Comment, this.updatingState.StatusDate)
          .then(() => {
            this.updatingStateId = null;
            this.updatingState = {};
            this.fetchData()
          });
      },
      createState() {
        if (this.creatingState.StatusId == -1) {
          window.alert("Vous devez sélectionner un statut");
          return;
        }

        mme.updateEstimateState(-1, this.activeLeadId, this.creatingState.StatusId, this.creatingState.Comment, this.creatingState.Date)
          .then(() => {
            this.creatingState = { StatusId: -1, Comment: "", Date: this.formatDateTime(new Date()) }
            this.fetchData()
          })
      }
    }
  }
</script>

<style scoped>
  .form-selection-container {
    background-color: white;
    border-radius: 12px;
    box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.4);
    padding: 12px 32px;
    margin-bottom: 32px;
  }

  .form-selection-container ul {
      list-style-type: none;
      display: grid;
      grid-template-columns: repeat(auto-fit, 400px);
      column-gap: 24px;
      row-gap: 12px;
  }

  .form-selection-container li label {
      display: grid;
      grid-template-areas: "input name  count"
                            "date date count";
      /*width: 320px;*/
      width: min-content;
      align-items: center;
      grid-template-columns: min-content 1fr min-content;
  }

  .form-selection-container li label .form-name {
      grid-area: name;
      white-space: nowrap;
      /*overflow: hidden;
      text-overflow: ellipsis;
*/  }

  .form-selection-container li label input {
      grid-area: input;
      margin-right: 12px;
  }

  .form-selection-container li label .form-date {
      grid-area: date;
      font-size: 0.9em;
      color: #777;
  }

  .form-selection-container li label .form-nb-lead {
      grid-area: count;
      margin-left: 24px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
  }

    .form-selection-container li label .form-nb-lead span {
        font-size: 0.9em;
    }

    .form-selection-container li label .form-nb-lead .number {
        font-size: 1.2em;
        font-weight: bold;
    }

  .overview-data {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    justify-items: center;
    align-items: center;
    column-gap: 16px;
    list-style-type: none;
    padding: 0;
    margin: 0;
    margin-bottom: 32px;
  }

  .green {
    color: rgb(120, 180, 120);
  }

  .yellow {
    color: rgb(220, 220, 120);
  }

  .orange {
    color: rgb(220, 180, 120);
  }

  .red {
    color: rgb(220, 140, 140);
  }

  .overview-data li {
    width: 100%;
    max-width: 500px;
    min-width: min-content;
    min-width: min-content;
    background-color: white;
    border-radius: 12px;
    box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.4);
    height: min-content;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 24px 32px;
    border-bottom: 12px solid black;
  }

    .overview-data li .section {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

      .overview-data li .count {
        font-weight: bold;
        font-size: 2em;
        white-space: nowrap;
      }
      .overview-data li .count small {
        font-weight: normal;
        font-size: 1rem;
        color: #777;
      }

    .overview-data li .sub-sections {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      column-gap: 24px;
      border-top: 1px solid #E2E2E2;
      margin-top: 16px;
    }

    .overview-data li .sub-sections .section {
        width: 100%;
        flex: 1;
    }

  .detail-overview-container {
    display: grid;
    grid-template-columns: 2fr 2fr 1fr 1fr;
    column-gap: 24px;
    margin-bottom: 32px;
  }

    .detail-overview-container > div {
      background-color: white;
      border-radius: 12px;
      box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.4);
      padding: 12px 32px;
      display: flex;
      flex-direction: column;
    }

      .detail-overview-container > div:nth-child(1) .content,
      .detail-overview-container > div:nth-child(2) .content {
        display: flex;
        justify-content: space-between;
        column-gap: 32px;
      }

        .detail-overview-container > div:nth-child(1) .content > div,
        .detail-overview-container > div:nth-child(2) .content > div {
          display: grid;
          grid-template-columns: 1fr 1fr;
          column-gap: 12px;
          white-space: nowrap;
          width: min-content;
          height: min-content;
        }

      .detail-overview-container > div:nth-child(3) .content,
      .detail-overview-container > div:nth-child(4) .content {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        row-gap: 12px;
      }

    .detail-overview-container h2,
    .form-selection-container h2,
    .lead-history-table-container h2,
    .leads-table-container h2 {
      font-size: 1em;
      font-weight: bold;
      padding-bottom: 12px;
      border-bottom: 3px solid #F2F2F2;
    }

    .leads-table-container h2 {
        margin: 0;
        padding: 0;
        border: none;
    }

    .form-selection-container h2 .icon {
        font-weight: normal;
        font-size: 1.5em;
    }

    .form-selection-container h2 .icon:hover {
        cursor: pointer;
    }


    .leads-table-container > div:nth-child(1) {
      border-bottom: 3px solid #F2F2F2;
    }

  .lead-history-table-container,
  .leads-table-container {
    background-color: white;
    border-radius: 12px;
    box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.4);
    padding: 12px 32px;
    min-width: 100%;
  }

  .lead-history-table {
    width: 100%;
  }

    .lead-history-table td, .lead-history-table th {
      padding: 8px 32px;
      font-weight: normal;
    }

    .lead-history-table thead {
      font-size: 1.15em;
      border-bottom: 2px solid #E2E2E2;
    }

    .lead-history-table td {
      min-width: 180px;
      max-width: 500px;
    }

    .lead-history-table td:nth-child(2) {
      max-width: 180px;
    }

    .lead-history-table td:nth-child(3) {
      min-width: 375px;
      max-width: 600px;
    }
</style>

<style>

  .leads-table {
    max-width: 100%;
    overflow-x: scroll;
  }

    .leads-table table,
    .leads-table thead,
    .leads-table thead th,
    .leads-table th,
    .leads-table td {
      border: none !important;
    }

    .leads-table thead {
      border-bottom: 2px solid #E2E2E2 !important;
    }

      .leads-table thead th {
        background: white;
        text-align: center;
      }

      .leads-table td a {
        color: black;
        text-decoration: none;
      }

    .leads-table .btn.detail-btn {
      background-color: black;
      color: white;
    }
</style>



// WEBPACK FOOTER //
// src/pages/MME/Leads.vue